import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {select, Store} from '@ngrx/store';
import * as fromFunkprotokollierungPage from './funkprotokollierung.reducer';
import {SettingsProvider} from '@orga-app/settings/settings.service';
import * as actionsUi from './funkprotokollierung.actions.ui';
import {FunkprotokollEintrag, FunkprotokollFall, FunkprotokollFallRequest, FunkprotokollVorlageDetail, Meldeart, Veranstaltung} from '../../../clients/veranstaltungen';
import {
    getAktuellerProtokollEintrag, getAktuellerProtokollFall, getAktuellerProtokollFallMeldungen, getFunkVorlagenListe, getFunkVorlagenListeFehler, getFunkVorlagenListeLaden, getIncident, getIncidentFehler,
    getIncidentLaden, getListeProtokollAbgeschlosseneFaelle, getListeProtokollAktiveFaelle, getMeldearten, getMeldeartenFehler, getMeldeartenLaden
} from './funkprotokollierung.selectors';
import {Observable} from 'rxjs';
import {takeWhile} from 'rxjs/operators';
import {ActionSheetController, IonInput, LoadingController, PopoverController, ToastController} from '@ionic/angular';
import {ErinnerungPopoverComponent} from './erinnerung-popover/erinnerung-popover.component';
import {DocumentService} from '@orga-app/providers/document.service';
import {getTheme} from '@orga-app/settings/reducer';
import {SafeUrl} from '@angular/platform-browser';
import {FunkprotokollFallUi} from './funkprotokollierung.model.ui';
import {PostFunkprotokollFallErinnerungSetzenAction} from '../../../client-ngrx/veranstaltungen';
import { Settings } from '@orga-app/settings';
import {ListInputItem} from '../../shared/sopi-list/sopi-list.model';
import {IncidentErstellenUiAction} from './funkprotokollierung.actions.ui';
import {IncidentKopf} from '../../../clients/incidents';
import {Router} from '@angular/router';
import {getAusgewaehlteVeranstaltung} from '../app-state/app-state.reducer';
import {VeranstaltungAuswaehlenParameter} from '../veranstaltung-auswaehlen/veranstaltung-auswaehlen.model.ui';
import {replaceSpecialCharacter} from '../../shared/wrapper/stringWrapper';
import {NotificationService} from '@orga-app/providers/notification.service';

@Component({
    selector: 'page-funkprotokollierung',
    templateUrl: './funkprotokollierung.page.html',
})
export class FunkprotokollierungPage implements OnInit {
    @ViewChild('fallTitel', {static: false}) fallTitel: IonInput;
    @ViewChild('eintragText', {static: false}) eintragText: IonInput;
    private alive = true;

    selectedTheme: Settings;
    public settings$: Observable<Settings>;
    themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;

    fallTyp = 'AktiveFaelle';
    fallErinnerung = 5;

    public now: Date = new Date();

    public aktuelleVeranstaltung$: Observable<Veranstaltung>;

    public aktuelleVeranstaltungId: string;

    public listeProtokollAktiveFaelle$: Observable<Array<ListInputItem>>;
    public listeProtokollAbgeschlosseneFaelle$: Observable<Array<ListInputItem>>;
    public aktuellerProtokollFall$: Observable<FunkprotokollFall>;

    public aktuellerProtokollFallMeldungen$: Observable<Array<ListInputItem>>;

    public aktuellerProtokollFallId: string;

    public incident$: Observable<IncidentKopf>;
    public incidentLaden$: Observable<boolean>;
    public incidentFehler$: Observable<boolean>;

    public meldearten$: Observable<Array<Meldeart>>;
    public meldeartenLaden$: Observable<boolean>;
    public meldeartenFehler$: Observable<boolean>;

    public funkVorlagenListe$: Observable<Array<FunkprotokollVorlageDetail>>;
    public funkVorlagenListeLaden$: Observable<boolean>;
    public funkVorlagenListeFehler$: Observable<boolean>;

    public aktuellerProtokollEintrag$: Observable<FunkprotokollEintrag>;

    public meldezeitpunkt: Date = new Date();

    funkprotokollSegment = 'fall';
    heute: Date;

    constructor(private store: Store<fromFunkprotokollierungPage.PageState>,
                private settings: SettingsProvider,
                public loadingCtrl: LoadingController,
                private documentService: DocumentService,
                public settingsProvider: SettingsProvider,
                public popoverController: PopoverController,
                private toastCtrl: ToastController,
                private router: Router,
                private actionsheetCtrl: ActionSheetController,
                private notificationService: NotificationService
    ) {
        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.store.pipe(select(getTheme));
        this.settings.getActiveTheme().subscribe(val => this.selectedTheme = val);

        this.aktuelleVeranstaltung$ = this.store.pipe(select(getAusgewaehlteVeranstaltung));

        this.listeProtokollAktiveFaelle$ = this.store.pipe(select(getListeProtokollAktiveFaelle));
        this.listeProtokollAbgeschlosseneFaelle$ = this.store.pipe(select(getListeProtokollAbgeschlosseneFaelle));
        this.aktuellerProtokollFall$ = this.store.pipe(select(getAktuellerProtokollFall));

        this.incident$ = this.store.pipe(select(getIncident));
        this.incidentLaden$ = this.store.pipe(select(getIncidentLaden));
        this.incidentFehler$ = this.store.pipe(select(getIncidentFehler));

        this.meldearten$ = this.store.pipe(select(getMeldearten));
        this.meldeartenLaden$ = this.store.pipe(select(getMeldeartenLaden));
        this.meldeartenFehler$ = this.store.pipe(select(getMeldeartenFehler));

        this.funkVorlagenListe$ = this.store.pipe(select(getFunkVorlagenListe));
        this.funkVorlagenListeLaden$ = this.store.pipe(select(getFunkVorlagenListeLaden));
        this.funkVorlagenListeFehler$ = this.store.pipe(select(getFunkVorlagenListeFehler));

        this.aktuellerProtokollFallMeldungen$ = this.store.pipe(select(getAktuellerProtokollFallMeldungen));


        this.aktuelleVeranstaltung$.subscribe((aktuelleVeranstaltung) => {
            if (aktuelleVeranstaltung != null) {
                this.aktuelleVeranstaltungId = aktuelleVeranstaltung.veranstaltung_id;
            }
        });

        this.aktuellerProtokollFall$.subscribe((aktuellerProtokollFall) => {
            if (aktuellerProtokollFall != null) {
                this.aktuellerProtokollFallId = aktuellerProtokollFall.fall_id;
            }
        });

        this.aktuellerProtokollEintrag$ = this.store.pipe(select(getAktuellerProtokollEintrag));
    }

    ngOnInit() {
        this.store.dispatch(new actionsUi.PageStateResetAction());

        setInterval(() => {
            this.now = new Date();
        }, 1000);
    }

    ionViewWillEnter() {
        this.heute = new Date();
        this.store.dispatch(new actionsUi.PageStateResetAction());
    }

    auswahlAufheben() {
        this.store.dispatch(new actionsUi.AuswahlAufheben());
    }

    veranstaltungenLaden() {
        this.store.dispatch(new actionsUi.PageStateResetAction());
    }

    veranstaltungAuswaehlen(veranstaltung: Veranstaltung) {
        this.store.dispatch(new actionsUi.VeranstaltungAusgewaehlt(veranstaltung));
    }

    protokollFallAuswaehlen(protokollFall: FunkprotokollFallUi) {
        this.store.dispatch(new actionsUi.ProtokollFallAusgewaehlt(protokollFall));
    }

    protokollFallEntfernen() {
        this.store.dispatch(new actionsUi.ProtokollFallEntfernen());
    }

    protokollFallSpeichern() {
        this.store.dispatch(new actionsUi.ProtokollFallSpeichern(false));
    }

    protokollFallSpeichernUndNeu() {
        this.store.dispatch(new actionsUi.ProtokollFallSpeichern(true));
        setTimeout(function () {
            this.fallTitel.setFocus();
        }.bind(this), 300);
    }

    protokollFallAbbrechenUndNeu() {
        this.store.dispatch(new actionsUi.NeuerProtokollFall());
        this.store.dispatch(new actionsUi.NeuerProtokollEintrag());
        this.meldezeitpunkt = new Date();
        setTimeout(function () {
            this.fallTitel.setFocus();
        }.bind(this), 300);
    }

    protokollFallEingabe($event, fall: FunkprotokollFall, propName: string, propTyp: string) {
        this.store.dispatch(new actionsUi.ProtokollFallEingabe(this.dokumentAendernInput($event, fall, propName, propTyp)));
    }

    protokollFallAbschliessen() {
        this.store.dispatch(new actionsUi.ProtokollFallAbschliessen());
    }

    protokollFallReaktivieren() {
        this.store.dispatch(new actionsUi.ProtokollFallReaktivieren());
    }

    protokollEintragAuswaehlen(protokollEintrag: FunkprotokollEintrag) {
        if (protokollEintrag) {
            this.store.dispatch(new actionsUi.ProtokollEintragAusgewaehlt(protokollEintrag));
            this.meldezeitpunkt = new Date(protokollEintrag.melde_zeitpunkt_utc);
            setTimeout(function () {
                this.eintragText.setFocus();
            }.bind(this), 300);
        }
    }

    protokollEintragEntfernen() {
        this.store.dispatch(new actionsUi.ProtokollEintragEntfernen());
    }

    protokollEintragSpeichern() {
        this.store.dispatch(new actionsUi.ProtokollEintragSpeichern(false));
    }

    protokollFallUndEintragSpeichern() {
        this.store.dispatch(new actionsUi.ProtokollFallUndEintragSpeichern(false, false));
    }

    protokollFallUndEintragSpeichernUndNeuerFall() {
        this.store.dispatch(new actionsUi.ProtokollFallUndEintragSpeichern(true, true));
        this.meldezeitpunkt = new Date();
        setTimeout(function () {
            this.fallTitel.setFocus();
        }.bind(this), 300);
    }

    protokollFallUndEintragSpeichernUndNeueMeldung() {
        this.store.dispatch(new actionsUi.ProtokollFallUndEintragSpeichern(false, true));
        this.meldezeitpunkt = new Date();
        setTimeout(function () {
            this.eintragText.setFocus();
        }.bind(this), 300);
    }

    protokollEintragSpeichernUndNeu() {
        this.store.dispatch(new actionsUi.ProtokollEintragSpeichern(true));
        setTimeout(function () {
            this.eintragText.setFocus();
        }.bind(this), 300);
    }

    protokollEintragAbbrechenUndNeu() {
        this.store.dispatch(new actionsUi.NeuerProtokollEintrag());
        this.meldezeitpunkt = new Date();
        setTimeout(function () {
            this.eintragText.setFocus();
        }.bind(this), 300);
    }

    protokollEintragEingabe($event, eintrag: FunkprotokollEintrag, propName: string, propTyp: string) {
        this.store.dispatch(new actionsUi.ProtokollEintragEingabe(this.dokumentAendernInput($event, eintrag, propName, propTyp)));
    }

    protokollEintragMeldeart(meldeart: Meldeart, eintrag: FunkprotokollEintrag, propName: string, propTyp: string) {
        eintrag = Object.assign({}, eintrag, {
            meldeart_id: meldeart.meldeart_id
        });

        this.store.dispatch(new actionsUi.ProtokollEintragEingabe(eintrag));
    }

    dokumentAendernInput<T>($event, dokument: T, propName: string, propTyp: string): T {

        if (propName !== null) {
            if (propTyp === 'date') {
                // DATE
                dokument = Object.assign({}, dokument, {[propName]: $event.value});
            } else if (propTyp === 'checkbox') {
                // Checkbox
                dokument = Object.assign({}, dokument, {[propName]: $event.detail.checked});
            } else if (propTyp === 'toggle') {
                // Toggle
                dokument = Object.assign({}, dokument, {[propName]: $event.detail.checked});
            } else if (propTyp === 'input') {
                // Input
                if ($event.code !== 'Tab') {
                    dokument = Object.assign({}, dokument, {[propName]: $event.target.value});
                }
            } else if (propTyp === 'area') {
                // Area
                dokument = Object.assign({}, dokument, {[propName]: $event.target.textContent});
            } else if (propTyp === 'range') {
                // Range
                dokument = Object.assign({}, dokument, {[propName]: $event.detail.value});
            } else {
                // SELECT
                dokument = Object.assign({}, dokument, {[propName]: $event});
            }
        }

        return dokument;
    }

    async excelAusgabe(veranstaltung: Veranstaltung) {
        if (veranstaltung != null && veranstaltung.veranstaltung_id != null) {
            const loading = await this.loadingCtrl.create({
                spinner: 'dots',
                message: 'Dokument wird geladen'
            });
            await loading.present();
            const url = '/api/query/veranstaltungen/funkprotokoll/' + veranstaltung.veranstaltung_id + '/excel';
            this.documentService.getDocument(url).pipe(takeWhile(() => this.alive))
                .subscribe(async document => {
                        if (document != null) {
                            await loading.dismiss();
                            this.documentService.saveFile(document, this.replaceSpecialCharacter(veranstaltung.titel) + '_funkprotokoll.xlsx');
                        } else {
                            // no content
                            await loading.dismiss();
                        }
                    },
                    async error => {
                        alert(error);
                        await loading.dismiss();
                    }, () => {
                    });
        }
    }

    replaceSpecialCharacter(value: string) {
        return value
            .replace(/:/g, '_')
            .replace(/ /g, '_')
            .replace(/ä/g, 'ae')
            .replace(/Ä/g, 'Ae')
            .replace(/ü/g, 'ue')
            .replace(/Ü/g, 'Ue')
            .replace(/ö/g, 'oe')
            .replace(/Ö/g, 'Oe')
            .replace(/ß/g, 'ss')
            .replace(/\//g, '-')
            .replace(/\\/g, '-')
            ;
    }

    erinnernRangeChange(range, fall) {
        this.fallErinnerung = range.detail.value;
        this.protokollFallEingabe(range, fall, 'erinnerung_in_minuten', 'range');
    }

    async erinnerungVerlaengern(e, fall) {
        const popover = await this.popoverController.create({
            component: ErinnerungPopoverComponent,
            componentProps: {fall: fall},
            event: e
        });

        popover.onDidDismiss().then(result => {
            if (result != null && result.data) {
                const request = <FunkprotokollFallRequest>{
                    veranstaltung_id: this.aktuelleVeranstaltungId,
                    fall_id: result.data.fall_id,
                    zeitpunkt_utc: new Date(Date.now()),
                    erinnerung_zeitpunkt_utc: result.data.erinnerung_zeitpunkt_utc,
                    erinnerung_in_minuten: result.data.erinnerung_in_minuten
                };
                this.store.dispatch(new PostFunkprotokollFallErinnerungSetzenAction(request));
            }
        });

        return popover.present();
    }

    @HostListener('document:keypress', ['$event'])
    async handleKeyboardEvent(event: KeyboardEvent) {
        if (event.ctrlKey === true && event.altKey === true && event.code === 'KeyN') {
            await this.protokollFallAbbrechenUndNeu();
        }
    }

    trackByFall(index, item) {
        return item.fall_id;
    }

    protokollEintrag2Auswaehlen(protokollFall: FunkprotokollFallUi) {
        if (protokollFall) {
            if (protokollFall.letzter_eintrag) {
                this.store.dispatch(new actionsUi.ProtokollEintragAusgewaehlt(protokollFall.letzter_eintrag));
                this.meldezeitpunkt = new Date(protokollFall.letzter_eintrag.melde_zeitpunkt_utc);
                setTimeout(function () {
                    this.eintragText.setFocus();
                }.bind(this), 300);
            }
        }
    }

    async incidentErstellen() {
        this.store.dispatch(new IncidentErstellenUiAction());
        await this.showToastIncidentAngelegt();
    }

    async showToastIncidentAngelegt() {
        const toast = await this.toastCtrl.create({
            message: 'Der Incident wurde ans Incident-Management weiter gegeben.',
            duration: 2000,
            cssClass: 'infoToast'
        });
        await toast.present();
    }

    veranstaltungWechseln() {
        this.router.navigate(['/veranstaltung-auswaehlen', { returnTo: window.location.pathname }],
            {
                preserveFragment: true,
                state: <VeranstaltungAuswaehlenParameter> { funk: true }
            });
    }

    async moreActions(veranstaltung: Veranstaltung) {
        const buttons = [];
        buttons.push({
            text: 'Export als Excel',
            icon: 'create',
            handler: () => {
                this.excelAusgabe(veranstaltung).then();
            }
        });

        buttons.push({
            text: 'Export als PDF',
            icon: 'download-outline',
            handler: () => {
                // Hier noch export einfügen
                this.downloadPdf(veranstaltung).then();
            }
        });

        buttons.push({
            text: 'Abbrechen',
            icon: 'close',
            role: 'cancel',
            handler: () => {
            }
        });

        const actionSheet = await this.actionsheetCtrl.create({
            header: 'Funkprotokoll-Aktionen',
            cssClass: 'action-sheets-basic-page',
            buttons
        });
        await actionSheet.present();
    }

    async downloadPdf(veranstaltung: Veranstaltung) {
        const loading = await this.loadingCtrl.create({
            spinner: 'dots',
            message: 'Funkprotokoll-Export für  ' + veranstaltung.titel + ' wird geladen'
        });
        await loading.present();

        const url = '/api/query/veranstaltungen/funkprotokoll/' + veranstaltung.veranstaltung_id + '/pdf';
        this.documentService.getDocument(url).pipe(
            takeWhile(() => this.alive)
        ).subscribe(async (doc) => {
                if (doc != null) {
                    await loading.dismiss();
                    this.documentService.saveFile(doc, replaceSpecialCharacter(veranstaltung.titel + '_funkprotokoll'));
                }
            },
            async (error) => {
                await this.notificationService.showMessageWithOk('Die Datei konnte nicht geladen werden.');
                await loading.dismiss();
            }, () => {
            });
    }

    async moreActionsDetail(fall: FunkprotokollFall) {
        const buttons = [];
        buttons.push({
            text: 'Export als PDF',
            icon: 'download-outline',
            handler: () => {
                this.downloadPdfDetail(fall).then();
            }
        });

        buttons.push({
            text: 'Abbrechen',
            icon: 'close',
            role: 'cancel',
            handler: () => {
            }
        });

        const actionSheet = await this.actionsheetCtrl.create({
            header: 'Funkprotokoll-Fall-Aktionen',
            cssClass: 'action-sheets-basic-page',
            buttons
        });
        await actionSheet.present();
    }

    async downloadPdfDetail(fall: FunkprotokollFall) {
        const loading = await this.loadingCtrl.create({
            spinner: 'dots',
            message: 'Funkprotokoll-Export für  ' + fall.titel + ' wird geladen'
        });
        await loading.present();

        const url = '/api/query/veranstaltungen/funkprotokoll/' + this.aktuelleVeranstaltungId + '/pdf' + '?fall_id=' + fall.fall_id;
        this.documentService.getDocument(url).pipe(
            takeWhile(() => this.alive)
        ).subscribe(async (doc) => {
                if (doc != null) {
                    await loading.dismiss();
                    this.documentService.saveFile(doc, replaceSpecialCharacter(fall.titel + '_funkprotokoll_fall'));
                }
            },
            async (error) => {
                await this.notificationService.showMessageWithOk('Die Datei konnte nicht geladen werden.');
                await loading.dismiss();
            }, () => {
            });
    }

    async showVorlagen(fall: FunkprotokollFall) {
        const buttons = [];
        let vorlagen = [];
        this.funkVorlagenListe$.subscribe((subVorlagen) => {
            vorlagen = subVorlagen;
        }).unsubscribe();

        vorlagen.forEach((vorlage) => {
            buttons.push({
                text: vorlage.titel,
               handler: () => {
                   this.store.dispatch(new actionsUi.ProtokollFallEingabeTitelMeldung( { titel: vorlage.titel, meldung: vorlage.beschreibung}));
                }
            });
        });

        buttons.push({
            text: 'Abbrechen',
            icon: 'close',
            role: 'cancel',
            handler: () => {
            }
        });

        const actionSheet = await this.actionsheetCtrl.create({
            header: 'Funkprotokoll-Vorlagen',
            cssClass: 'action-sheets-basic-page',
            buttons
        });
        await actionSheet.present();
    }
}
